var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 855,
    height: 824,
    viewBox: "0 0 855 824",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.5 38.41C751.15 -50.92 523.11 38.03 427.5 79.41C225.5 166.83 37.15 258.1 5.49997 416.41C-18.69 537.41 37.44 690 162.5 763.41C297.9 842.89 411.34 840.82 498.5 774.41C550.71 734.63 567 701.13 722.5 456.41C772.82 377.21 802.5 325.41 825.5 258.41C836.72 225.71 852.05 182.41 854.5 135.41C856.3 100.93 846.4 60.52 827.5 38.41Z",
    fill: "#1F244D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.22 163.28C707.776 163.28 737.41 133.646 737.41 97.09C737.41 60.5343 707.776 30.9 671.22 30.9C634.664 30.9 605.03 60.5343 605.03 97.09C605.03 133.646 634.664 163.28 671.22 163.28Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.7 59.11C668.897 59.11 672.3 55.7074 672.3 51.51C672.3 47.3127 668.897 43.91 664.7 43.91C660.503 43.91 657.1 47.3127 657.1 51.51C657.1 55.7074 660.503 59.11 664.7 59.11Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.73 135.07C681.927 135.07 685.33 131.667 685.33 127.47C685.33 123.273 681.927 119.87 677.73 119.87C673.533 119.87 670.13 123.273 670.13 127.47C670.13 131.667 673.533 135.07 677.73 135.07Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.02 90.58C710.019 90.58 712.45 88.1489 712.45 85.15C712.45 82.1511 710.019 79.72 707.02 79.72C704.021 79.72 701.59 82.1511 701.59 85.15C701.59 88.1489 704.021 90.58 707.02 90.58Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.17 119.87C654.758 119.87 662.53 112.098 662.53 102.51C662.53 92.9224 654.758 85.15 645.17 85.15C635.582 85.15 627.81 92.9224 627.81 102.51C627.81 112.098 635.582 119.87 645.17 119.87Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.34 209.94C449.332 209.94 454.19 205.082 454.19 199.09C454.19 193.098 449.332 188.24 443.34 188.24C437.348 188.24 432.49 193.098 432.49 199.09C432.49 205.082 437.348 209.94 443.34 209.94Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.15 238.15C740.142 238.15 745 233.292 745 227.3C745 221.308 740.142 216.45 734.15 216.45C728.158 216.45 723.3 221.308 723.3 227.3C723.3 233.292 728.158 238.15 734.15 238.15Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.02 254.43C608.615 254.43 611.53 251.515 611.53 247.92C611.53 244.325 608.615 241.41 605.02 241.41C601.425 241.41 598.51 244.325 598.51 247.92C598.51 251.515 601.425 254.43 605.02 254.43Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.7 459.52C107.295 459.52 110.21 456.605 110.21 453.01C110.21 449.415 107.295 446.5 103.7 446.5C100.105 446.5 97.19 449.415 97.19 453.01C97.19 456.605 100.105 459.52 103.7 459.52Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.91 634.22C492.505 634.22 495.42 631.305 495.42 627.71C495.42 624.115 492.505 621.2 488.91 621.2C485.315 621.2 482.4 624.115 482.4 627.71C482.4 631.305 485.315 634.22 488.91 634.22Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.92 441.11L604.67 444.34L601.44 441.09L599.27 443.24L602.5 446.49L599.25 449.72L601.4 451.89L604.65 448.66L607.88 451.91L610.05 449.76L606.82 446.51L610.07 443.28L607.92 441.11Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.12 547.46L140.87 550.68L137.65 547.43L135.48 549.58L138.71 552.83L135.46 556.06L137.61 558.23L140.86 555L144.09 558.25L146.25 556.1L143.03 552.85L146.28 549.62L144.12 547.46Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.17 358.64L182.92 361.87L179.69 358.62L177.52 360.77L180.75 364.02L177.5 367.25L179.65 369.42L182.9 366.19L186.13 369.44L188.3 367.29L185.07 364.04L188.32 360.81L186.17 358.64Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.69 157.9L750.44 161.12L747.21 157.87L745.04 160.02L748.27 163.27L745.02 166.5L747.17 168.67L750.42 165.44L753.65 168.69L755.82 166.54L752.59 163.29L755.84 160.06L753.69 157.9Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.6 247.96L494.35 251.19L491.12 247.94L488.95 250.09L492.18 253.34L488.93 256.57L491.08 258.73L494.33 255.51L497.56 258.76L499.73 256.6L496.5 253.35L499.75 250.13L497.6 247.96Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.13 408.86L553.13 370.26L586.13 331.66L604.74 309.87C605.74 308.67 604.19 306.79 603.16 307.99L570.16 346.59L537.16 385.19L518.5 406.98C517.5 408.19 519.1 410.07 520.13 408.86Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.5 547.76L511.5 509.16L544.5 470.56L563.11 448.77C564.11 447.56 562.55 445.68 561.52 446.89L528.52 485.49L495.52 524.09L476.91 545.88C475.91 547.08 477.46 548.96 478.49 547.76H478.5Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14 381.93L396.42 382.5L396.14 383.02V381.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87 518.1L206.74 542.57V576.81L241.87 554.79V518.1Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87 618.38V554.79L195.77 584.14V642.85L241.87 618.38Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.33 300.41C351.89 300.75 385.95 417.01 391.18 505.85C393.802 551.922 389.357 598.123 378 642.85C357.807 632.028 335.33 626.163 312.424 625.739C289.518 625.315 266.84 630.343 246.26 640.41C234.81 593.218 231.118 544.478 235.33 496.1C242.73 412.73 277.26 300.09 314.33 300.41Z",
    fill: "#F2463A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4 519.94L417.54 544.41V578.65L382.4 556.64V519.94Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4 620.23V556.64L428.5 585.99V644.7L382.4 620.23Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.35 506.12C387.12 417.25 353.07 300.99 315.5 300.68H314.33V626.01C336.979 626.609 359.18 632.452 379.19 643.08C390.532 598.364 394.97 552.177 392.35 506.12Z",
    fill: "#D23B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.64 699.65C355.374 695.827 355.748 691.943 355.76 688.05C355.76 660.11 337.7 637.47 315.43 637.47C293.16 637.47 275.11 660.11 275.11 688.05C275.11 691.943 275.478 695.827 276.21 699.65L315.43 649.81L354.64 699.65Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29 724.24L286.44 723.17L287.29 724.24Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41 723.16L343.56 724.24C343.82 723.89 344.12 723.52 344.41 723.16Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.29 724.24L315.43 759.99L343.56 724.24C330.19 741.55 306.75 743.51 291.22 728.61C289.802 727.254 288.488 725.793 287.29 724.24Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.64 699.65L315.43 649.81L276.21 699.65C277.727 708.184 281.232 716.241 286.44 723.17L287.29 724.24C300.66 741.55 324.1 743.51 339.63 728.61C341.048 727.254 342.362 725.793 343.56 724.24L344.41 723.16C349.624 716.239 353.13 708.183 354.64 699.65Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 685.69C343.019 682.947 343.283 680.162 343.29 677.37C343.29 657.37 330.29 641.08 314.35 641.08C298.41 641.08 285.37 657.33 285.37 677.41C285.367 680.202 285.631 682.988 286.16 685.73L314.3 649.97L342.5 685.69Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.14 703.41L293.52 702.64C293.73 702.87 293.92 703.13 294.14 703.41Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.12 702.62L334.5 703.41L335.12 702.62Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.14 703.41L314.31 729.07L334.5 703.41C324.91 715.83 308.1 717.24 296.96 706.55C295.938 705.58 294.995 704.53 294.14 703.41Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 685.69L314.3 649.93L286.17 685.69C287.26 691.812 289.771 697.594 293.5 702.57L294.12 703.35C303.7 715.76 320.52 717.17 331.66 706.49C332.675 705.513 333.617 704.463 334.48 703.35L335.1 702.57C338.859 697.603 341.395 691.82 342.5 685.69Z",
    fill: "#8991DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.28 679.41C335.682 677.3 335.889 675.158 335.9 673.01C335.9 657.61 325.9 645.11 313.66 645.11C301.42 645.11 291.4 657.61 291.4 673.01C291.411 675.158 291.618 677.3 292.02 679.41L313.66 651.92L335.28 679.41Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14 692.98L297.66 692.39L298.14 692.98Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.64 692.41L329.16 693L329.64 692.41Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14 692.98L313.66 712.77L329.16 692.98C321.77 702.53 308.83 703.58 300.26 695.35C299.494 694.615 298.785 693.823 298.14 692.98Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.28 679.41L313.66 651.92L292.02 679.41C292.849 684.127 294.782 688.582 297.66 692.41L298.14 693C305.53 702.55 318.47 703.6 327.04 695.37C327.806 694.635 328.515 693.843 329.16 693L329.64 692.41C332.518 688.582 334.451 684.127 335.28 679.41Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.53 488.76C340.786 488.76 360.45 466.853 360.45 439.83C360.45 412.807 340.786 390.9 316.53 390.9C292.274 390.9 272.61 412.807 272.61 439.83C272.61 466.853 292.274 488.76 316.53 488.76Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.53 474.07C333.507 474.07 347.27 458.74 347.27 439.83C347.27 420.92 333.507 405.59 316.53 405.59C299.553 405.59 285.79 420.92 285.79 439.83C285.79 458.74 299.553 474.07 316.53 474.07Z",
    fill: "#D1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.97 373.24C323.105 373.24 329.7 365.897 329.7 356.84C329.7 347.782 323.105 340.44 314.97 340.44C306.835 340.44 300.24 347.782 300.24 356.84C300.24 365.897 306.835 373.24 314.97 373.24Z",
    fill: "#4B518C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.97 368.33C320.664 368.33 325.28 363.186 325.28 356.84C325.28 350.494 320.664 345.35 314.97 345.35C309.276 345.35 304.66 350.494 304.66 356.84C304.66 363.186 309.276 368.33 314.97 368.33Z",
    fill: "#D1D5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854.71,
    height: 823.66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.faaf8b157a5f6159bc6bf2d802c5a8bd.svg";
export { ForwardRef as ReactComponent };